var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.079,
    height: 10.886,
    viewBox: "0 0 17.079 10.886",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view_2_",
    "data-name": "view (2)",
    transform: "translate(0 -92.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(0 92.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M16.971,97.946c-.153-.209-3.788-5.111-8.431-5.111s-8.279,4.9-8.431,5.11a.564.564,0,0,0,0,.665c.152.209,3.788,5.111,8.431,5.111s8.279-4.9,8.431-5.11A.563.563,0,0,0,16.971,97.946Zm-8.431,4.649c-3.42,0-6.382-3.253-7.259-4.317.876-1.065,3.832-4.316,7.259-4.316s6.382,3.253,7.259,4.317C14.923,99.343,11.967,102.595,8.539,102.595Z",
    transform: "translate(0 -92.835)",
    fill: "#004c75"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(5.161 94.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M158.1,154.725a3.378,3.378,0,1,0,3.378,3.378A3.382,3.382,0,0,0,158.1,154.725Zm0,5.63a2.252,2.252,0,1,1,2.252-2.252A2.255,2.255,0,0,1,158.1,160.355Z",
    transform: "translate(-154.722 -154.725)",
    fill: "#004c75"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewicon);
export default __webpack_public_path__ + "static/media/Viewicon.baf70559b66be97b5241364dba0272f1.svg";
export { ForwardRef as ReactComponent };